import { FC } from "react";
import SourceDataCtcaeValue from "./SourceDataCtcaeValue";
import SourceDataFileValue from "./SourceDataFileValue";
import { FieldType } from '@/api/dtos';
import { Field, Format } from '.';
import { Box } from "@mui/material";

const SourceDataFormFieldValue: FC<{fieldType?: FieldType; formFieldValue?: string; oldValue?: boolean; newValue?: boolean; noBox?: boolean }> = ({
    fieldType,
    formFieldValue,
    newValue,
    oldValue,
    noBox
}) => {

    switch (fieldType) {
        case FieldType.Ctcae: 
            return(
                <SourceDataCtcaeValue 
                    formFieldValue={formFieldValue}
                    oldValue={oldValue}
                    newValue={newValue}
                    noBox={noBox}
                />
            );
        case FieldType.File: 
            return (
                <SourceDataFileValue 
                    formFieldValue={formFieldValue}
                    oldValue={oldValue}
                    newValue={newValue}
                    noBox={noBox}
                />
            );
        default:
            return (
                <Field
                    // @ts-ignore-next-line
                    newValue={newValue ? "1" : undefined} 
                    oldValue={oldValue ? "1" : undefined}
                    noBox={noBox ? "1" : undefined}
                >
                    <Format>
                        <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis'}}>
                            {formFieldValue}
                        </Box>
                    </Format>
                </Field>
            );
    }

    
}

export default SourceDataFormFieldValue;